import { ClickableCross } from 'components/Buttons/ClickableIcon/ClickableIcon.styles'
import styled from 'styled-components'

import crossDark from 'images/crossDark.svg';
import crossBlack from 'images/crossBlack.svg';

export const CrossButton = styled(ClickableCross)`
	position: absolute;
	top: 30px;
	right: 30px;
	width: 20px;
	height: 20px;
	
	:hover {
		transform: scale(1.1);
	}
	transition: 200ms ease;
`

export const CrossButtonDark = styled(CrossButton).attrs({
	src: crossDark,
})``

export const CrossButtonBlack = styled(ClickableCross).attrs({
	src: crossBlack,
})`
	width: 16px;
	height: 16px;

	:hover {
		transform: scale(1.1);
	}
	transition: 200ms ease;
`
